import WorkflowToken from '@apps/automation/admin/tokens/workflow'
import Container from '@admin/components/container'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Workflow extends React.PureComponent {

  static propTypes = {
    config: PropTypes.object,
    workflows: PropTypes.array,
    program: PropTypes.object,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onDone: PropTypes.func,
    onTokens: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    this.setState({
      config: {
        ...this.props.config || {}
      }
    })
  }

  _getForm() {
    const { program } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      title: 't(Enroll in Workflow)',
      onChange: this._handleChange,
      onCancel: this._handleCancel,
      onSubmit: this._handleDone,
      cancelSvg: 'chevron_left',
      saveText: null,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      sections: [
        {
          fields: [
            { 
              label: 't(Workflow)', 
              name: 'workflow_id', 
              type: 'lookup', 
              required: true, 
              prompt: 'Choose a workflow', 
              endpoint: '/api/admin/automation/workflows', 
              filter: { program_id: { $eq: program.id } }, 
              format: (workflow) => (
                <WorkflowToken workflow={ workflow }/>
              ), 
              valueKey: 'id', 
              textKey: 'title', 
              defaultValue: config.workflow_id 
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.props.onCancel()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleDone(config) {
    const { workflows } = this.props
    const workflow = _.find(workflows, { id: config.workflow_id })
    this.props.onDone({
      ...config,
      workflow: workflow ? {
        id: workflow.id,
        title: workflow.title
      } : null
    })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

}
const mapResources = (props, context) => ({
  workflows: '/api/admin/automation/workflows'
})

export default Container(mapResources)(Workflow)
